import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import { lessonService } from '../../_services/lesson.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

class LessonSelectForAdmin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      defaultValue: '',
      data: [],
    };
  }

  componentWillMount() {
    this.getData();
  }

  getData() {
    lessonService.getAll()
      .then((res) => {
        // console.log(res.data)
        let data = res.data.map(elm => ({ "label": elm.name, "value": elm.id }))
        this.setState({ data: data, loading: false, isSubmitting: false });
      })
  };

  handleChange = e => {
    if (e) {
      this.props.onChange(e.value);
    } else {
      this.props.onChange(undefined);
    }
  }

  render() {
    const { style } = this.props;
    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0,
      }),
      menuList: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0,
      }),
      option: (provided, state) => ({
        ...provided,
        padding: 10,
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#6d6d6d',
      }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#fff',
        borderRadius: 7,
        height: 40,
        boxShadow: 'none',
        paddingRight: '12',
        border: 'thin solid #b4b4b4',
        // marginBottom: 15
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),

    }
    const { loading, data } = this.state;
    const { disabled, required } = this.props;

    return (
      <div>
        {!loading &&
          <Select
            isClearable
            isDisabled={disabled}
            placeholder=""
            styles={customStyles}
            options={data}
            onChange={this.handleChange}
            value={this.props.defaultValue}
          className={required ? "select required" : "select"}
          />
        }
      </div>
    );
  }
}
export default LessonSelectForAdmin;
